import React from 'react';
import ReactSVG from "react-svg";
import messages_en from "../en/messages_en";

const savingsGoalBuilderKey = 'savingsGoalTypes';
const borrowGoalsBuilderKey = 'borrowGoalTypes';

const renderCardTitle = (builderKey, cardKey) => {
  const icon = messages_en[`${builderKey}.${cardKey}.icon`];
  const label = messages_en[`${builderKey}.${cardKey}.label`];
  return <div>
    <ReactSVG src={icon} className='card-title-icon' />
    <span>{ label }</span>
  </div>
};

export default {
  'savingsGoalTypes.rainyDayGoal': renderCardTitle(savingsGoalBuilderKey, 'rainyDayGoal'),
  'savingsGoalTypes.retirementFundGoal': renderCardTitle(savingsGoalBuilderKey, 'retirementFundGoal'),
  'savingsGoalTypes.collegeFundGoal': renderCardTitle(savingsGoalBuilderKey, 'collegeFundGoal'),
  'savingsGoalTypes.eventWeddingGoal': renderCardTitle(savingsGoalBuilderKey, 'eventWeddingGoal'),
  'savingsGoalTypes.provideForChildGoal': renderCardTitle(savingsGoalBuilderKey, 'provideForChildGoal'),
  'savingsGoalTypes.otherSavingsGoal': renderCardTitle(savingsGoalBuilderKey, 'otherSavingsGoal'),

  'borrowGoalTypes.purchaseHomeGoal': renderCardTitle(borrowGoalsBuilderKey, 'purchaseHomeGoal'),
  'borrowGoalTypes.refinanceHomeGoal': renderCardTitle(borrowGoalsBuilderKey, 'refinanceHomeGoal'),
  'borrowGoalTypes.homeImprovementGoal': renderCardTitle(borrowGoalsBuilderKey, 'homeImprovementGoal'),
  'borrowGoalTypes.payOffDebtsGoal': renderCardTitle(borrowGoalsBuilderKey, 'payOffDebtsGoal'),
  'borrowGoalTypes.purchaseVehicleGoal': renderCardTitle(borrowGoalsBuilderKey, 'purchaseVehicleGoal'),
  'borrowGoalTypes.refinanceVehicleGoal': renderCardTitle(borrowGoalsBuilderKey, 'refinanceVehicleGoal'),
  'borrowGoalTypes.collegeEducationGoal': renderCardTitle(borrowGoalsBuilderKey, 'collegeEducationGoal'),
  'borrowGoalTypes.otherBorrowingGoal': renderCardTitle(borrowGoalsBuilderKey, 'otherBorrowingGoal'),
};
